<template>
  <div class="perject">
    <wap-header :isShow.sync="isShow" :isTransparent.sync="isTransparent"></wap-header>

    <img src="~@/assets/wap/project.jpg" @click="onHide" />
  </div>
</template>

<script>
import wapHeader from "@/components/wapHeader"

export default {
  components: {
    "wap-header": wapHeader
  },
  metaInfo: {
    title: "项目历程|东阳光冬虫夏草官网",
    meta: [
      {
        name: "keywords",
        content: "关键字"
      },
      {
        name: "description",
        content: "网页描述"
      }
    ]
  },
  data () {
    return {
      isShow: false, // 是否显示
      isTransparent: true // 是否透明
    }
  },
  methods: {
    onHide () {
      this.isShow = false
    }
  }
}
</script>

<style scoped lang="stylus">
.perject {
  margin-top: 80px;
}

img {
  width: calc(100%);
}
</style>



// WEBPACK FOOTER //
// wapProject.vue